<div class="keycloak-bg d-flex align-items-center text-center flex-column h-100">
  <p class="logo">
    {{ NAME_PROJECT }}
  </p>
  <div class="form">
    <h1 class="form-title">{{ 'additional_information' | translate }}</h1>
    <div class="d-flex justify-content-center">
      <div class="d-flex flex-column align-items-center w-80">
        <app-phone-field
          class="w-100"
          [customClass]="'w-100 h-100 input-standard'"
          [ngClass]="{ 'danger-border': this.phoneForm.controls.phone.status === 'INVALID' && !focused && isSubmitted }"
          label="{{ 'your_phone_number' | translate }}"
          [placeholder]="'+380987654321'"
          [error]="this.phoneForm.controls.phone.status === 'INVALID' && !focused && isSubmitted"
          (focusin)="focused = !focused"
          (focusout)="focused = !focused"
          [formControl]="phoneForm.controls.phone"
        ></app-phone-field>
        @if (validation) {
          <div class="d-flex justify-content-start w-100">
            <label class="label text-danger">{{ 'field_cannot_be_empty' | translate }}</label>
          </div>
        }
      </div>
    </div>
    <div class="pt-5">
      <button (click)="addPhoneIntoProfile()" [disabled]="isButtonDisabled" class="btn w-80 p-0">
        <span class="btn-text">{{ 'add_phone_number' | translate }}</span>
      </button>
    </div>
    <div class="pt-2 cursor-pointer" (click)="goBack()">
      <span class="btn-text">{{ 'go_back' | translate }}</span>
    </div>
  </div>
</div>
